export const appconfig = { appId: 21 };
